<div class="main-card mb-3 card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <span class="font-weight-bold fs-1r">Subscription Plans</span>
    <button class="btn btn-primary" (click)="openAddPlan()">+ Add Plan</button>
  </div>

  <!-- Tabs -->
  <ul class="nav nav-tabs" id="planTabs" role="tablist">
    <li class="nav-item">
      <a
        class="nav-link active"
        id="plans-tab"
        data-bs-toggle="tab"
        href="#plans"
        role="tab"
        (click)="getPlans(1)"
      >
        Plans
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        id="topup-tab"
        data-bs-toggle="tab"
        href="#top-up"
        role="tab"
        (click)="getPlans(2)"
      >
        Top up
      </a>
    </li>
  </ul>

  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
    >
      <thead>
        <tr>
          <th>Plan Name</th>
          <th>Price</th>

          <th>Trip KM</th>
     

          <th *ngIf="activePlanType == 1">Stops / trip</th>

          <th *ngIf="activePlanType == 1">Validity Days</th>

          <th>Tax</th>
          <th>Commission</th>
          <th>Discount</th>
          <th>Created At</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let plan of allPlanList">
          <tr>
            <td>{{ plan.name }}</td>
            <td>₹ {{ plan.price }}</td>

            <td>{{ plan.tripKM }}</td>

            <td *ngIf="plan.planType == 1">{{ plan.stopsPerTrip }}</td>

            <!-- MAIN PLAN -->
            <td *ngIf="plan.planType == 1">{{ plan.validityDays }}</td>

            <td>{{ plan.tax }}%</td>
            <td>{{ plan.commission }}%</td>
            <td>{{ plan.discount }}%</td>
            <td>{{ plan.createdAt }}</td>

            <td class="text-end">
              <div class="dropdown">
                <button
                  class="btn btn-sm btn-warning dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  Actions
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" (click)="openEditPlan(plan)"
                      >Edit</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item text-danger"
                      (click)="deletePlan(plan._id)"
                      >Delete</a
                    >
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<app-add-update-subscription-plan
  [subscriptionData]="selectedPlan"
  [showModal]="showModal"
  (closeModal)="handleCloseModal()"
  (save)="handleSave($event)"
>
</app-add-update-subscription-plan>
